<template>
  <div id="app">
    <Preloader :start="load.val"/>

    <router-view />
  </div>
</template>

<script>
import Preloader from '@/components/preloader.vue';
import axios from 'axios'

export default {
  name: "App",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${process.env.VUE_APP_NAME}` : process.env.VUE_APP_NAME;
    },
  },
  components: {Preloader},
  data:() => ({
    load : {
      val : false
    },
    refCount: 0 
  }),
  methods: {
    setLoading(isLoading) {
      if (isLoading) {
        this.refCount++;
        this.load.val = true;
      } else if (this.refCount > 0) {
        this.refCount--;
        this.load.val = (this.refCount > 0);
      }
    }
  },
  created() {
    axios.interceptors.request.use((config) => {
      // Check if preloader should be disabled for this request
      if (!config.hidePreloader) {
        this.setLoading(true);
      }
      return config;
    }, (error) => {
      this.setLoading(false);
      return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
      // Only hide preloader if it wasn't disabled for this request
      if (!response.config.hidePreloader) {
        this.setLoading(false);
      }
      return response;
    }, (error) => {
      // Hide preloader on error regardless
      this.setLoading(false);
      return Promise.reject(error);
    });
  },
  provide() {
    return {
      loader : this.load
    }
  }
};
</script>
